import { programRequestsApi } from '../api/programRequestsApi';
import { toCreateChangeStatusRequest } from './changeStatusModel';

export const createChangeStatusFlow = async ({
    form,
    onError,
    api = programRequestsApi,
}) => Boolean(
    await api.createChangeStatusRequest(toCreateChangeStatusRequest(form), onError)
);
